import { Component, inject, OnInit } from '@angular/core';
import { MenuComponentBase } from '../../base-classes/menu-component-base';
import { Router } from '@angular/router';

@Component({
  selector: 'app-subscription-status',
  templateUrl: './subscription-status.component.html',
  styleUrls: ['./subscription-status.component.scss'],
  standalone: true,
})
export class SubscriptionStatusComponent
  extends MenuComponentBase
  implements OnInit
{
  private router = inject(Router);
  status = 'success';

  override ngOnInit(): void {
    super.ngOnInit();
    this.route.queryParams.subscribe((params) => {
      this.status = params['status'];
    });
  }

  redirectTo(): void {
    this.router.navigate(['/manage-subscriptions']);
  }
}
